import React from 'react';

import { Button, Group, Stack } from '@mantine/core';
import { ContextModalProps } from '@mantine/modals';

import { ModalDescription } from 'components/modals/ModalDescription';
import { ModalTitle } from 'components/modals/ModalTitle';
import { useAction } from 'hooks/use-action';

type Props = {
    title: string;
    description?: React.ReactNode;
    children?: React.ReactNode;
    confirm: () => void | Promise<void>;
    confirmLabel: string;
};

const ConfirmationModal = ({ context, id, innerProps }: ContextModalProps<Props>) => {
    const { title, description, children = null, confirm, confirmLabel } = innerProps;

    const centered = !!description;

    const [handleConfirm, confirming] = useAction(async () => {
        if (confirming) {
            return;
        }

        await confirm();
        context.closeModal(id);
    });

    const handleCancel = () => {
        if (!confirming) {
            context.closeModal(id);
        }
    };

    return (
        <Stack gap="sm" p="sm">
            <ModalTitle ta={centered ? 'center' : 'left'}>{title}</ModalTitle>
            {description && <ModalDescription ta="center">{description}</ModalDescription>}
            {children}
            <Group gap="4" justify={centered ? 'center' : 'left'}>
                <Button size="sm" onClick={handleConfirm} loading={confirming}>
                    {confirmLabel}
                </Button>
                <Button size="sm" variant="subtle" onClick={handleCancel}>
                    Cancel
                </Button>
            </Group>
        </Stack>
    );
};

export { ConfirmationModal };
